import { FilterViewProps } from "@mb-pro-ui/components/table/filters/base/types";
import { useIntl } from "react-intl";
import { Firmware } from "../../utils/types";
import AutocompleteFilter from "./AutocompleteFilter";
import { FirmwareItem } from "../FirmwareItem";
import { StringId } from "./utils";

type FirmwareWithStringId = StringId<Firmware>;

// a width valamiért akkor jelenik meg jól, ha kisebb számot írok be, mint amekkora a hely.
const renderOption = (option: FirmwareWithStringId) => <FirmwareItem item={option} sx={{width: 10}} />;

const getOptionLabel = (option: FirmwareWithStringId) => option.description;
const getFilterValue = (option: FirmwareWithStringId) => option.id;

export const FirmwareFilter = ({firmwares, ...props}: FilterViewProps & {firmwares: StringId<Firmware>[]}) => {
  const { formatMessage } = useIntl();

  return (
    <AutocompleteFilter
      {...props}
      options={firmwares}
      getOptionLabel={getOptionLabel}
      renderOption={renderOption}
      getFilterValue={getFilterValue}
      label={formatMessage({
        defaultMessage: "Firmware",
      })}
      virtualizedRowHeight={142}
    />
  );
};
